(function($){

	$(document).ready(function(){

		$('.slider-module__slider').each(function(index){
	
			if(!$(this).hasClass('slick-initialized')) {

				$(this).slick({
			        slidesToShow: 1,
			        slidesToScroll: 1,
			        arrows: true,
			        dots: true,
			        infinite: true,
			        autoplay: true,
			        autoplaySpeed: 5000,
			        swipe: true,
			        prevArrow: '<button class="slick-prev"><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M20 40C8.9543 40 0 31.0457 0 20C0 8.9543 8.9543 0 20 0C31.0457 0 40 8.9543 40 20C40 31.0457 31.0457 40 20 40Z" fill="#F8F8F8"/><path fill-rule="evenodd" clip-rule="evenodd" d="M12.6 20L22.5643 30L24 28.5603L15.4074 19.9773L23.9773 11.417L22.5643 10L12.6 20Z" fill="#3B3B3C"/></svg></button>',
			        nextArrow: '<button class="slick-next"><svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg"><path fill-rule="evenodd" clip-rule="evenodd" d="M20 40C31.0457 40 40 31.0457 40 20C40 8.9543 31.0457 0 20 0C8.9543 0 0 8.9543 0 20C0 31.0457 8.9543 40 20 40Z" fill="#F8F8F8"/><path fill-rule="evenodd" clip-rule="evenodd" d="M27.4 20L17.4357 30L16 28.5603L24.5926 19.9773L16.0227 11.417L17.4357 10L27.4 20Z" fill="#3B3B3C"/></svg></button>'
			    });  
			}
		});

	});
	
})(jQuery);